jQuery(document).ready(function($) {
    
    var utm_campaign = Cookies.get('utm_campaign') ? Cookies.get('utm_campaign') : "";
    var utm_medium = Cookies.get('utm_medium') ? Cookies.get('utm_medium') : "";
    var utm_source = Cookies.get('utm_source') ? Cookies.get('utm_source') : "";

    if ( ! utm_campaign ) {
        utm_campaign = ckGetQueryVariable('utm_campaign');
        if ( utm_campaign ) {
            Cookies.set('utm_campaign', utm_campaign, { expires: 60 });
        }
        utm_medium = ckGetQueryVariable('utm_medium');
        if ( utm_medium ) {
            Cookies.set('utm_medium', utm_medium, { expires: 60 });
        }
        utm_source = ckGetQueryVariable('utm_source');
        if ( utm_source ) {
            Cookies.set('utm_source', utm_source, { expires: 60 });
        }
    }
    if ( ( $(".seva-form").length > 0 ) ) {
        if ( utm_campaign ) {
            $("form").addClass('ext-ck');
            $("<input>").attr({
                name: "fields[utm_campaign]",
                id: "fields[utm_campaign]",
                type: "hidden",
                value: utm_campaign
            }).appendTo("form");
        }
        if ( utm_medium ) {
            $("form").addClass('ext-ck');
            $("<input>").attr({
                name: "fields[utm_medium]",
                id: "fields[utm_medium]",
                type: "hidden",
                value: utm_medium
            }).appendTo("form");
        }
        if ( utm_source ) {
            $("form").addClass('ext-ck');
            $("<input>").attr({
                name: "fields[utm_source]",
                id: "fields[utm_source]",
                type: "hidden",
                value: utm_source
            }).appendTo("form");

        }
    }
    jQuery(document).on('click', '.formkit-submit', function() {
        var utm_sent;
        if (utm_campaign) {
            Cookies.remove('utm_campaign');
            Cookies.set('utm_sent', utm_sent, { expires: 365 } );
        }
        if (utm_medium) {
            Cookies.remove('utm_medium');
            Cookies.set('utm_sent', utm_sent, { expires: 365 } );
        }
        if (utm_source) {
            Cookies.remove('utm_source');
            Cookies.set('utm_sent', utm_sent, { expires: 365 } );
        }
    });
    /**
     * This function will check for the query parameter
     * and if it exists return the value and remove it from the URL.
     *
     * @param variable
     * @returns {*}
     */
    function ckGetQueryVariable(variable)
    {
        var query = window.location.search.substring(1);
        var vars = query.split("&");
        for (var i=0;i<vars.length;i++) {
            var pair = vars[i].split("=");
            if(pair[0] == variable){
                return pair[1];
            }
        }
        return false;
    }

});